import { render, staticRenderFns } from "./ElencoClienti.vue?vue&type=template&id=75ab8430"
import script from "./ElencoClienti.vue?vue&type=script&lang=js"
export * from "./ElencoClienti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports